import { c as _c } from "react/compiler-runtime";
import { DocumentRequestKind, DocumentUploadSettings } from '@onefootprint/types';
import { NavigationHeader } from '@/idv/components';
import ErrorComponent from '../../../components/error';
import FadeInContainer from '../../../components/fade-in-container';
import IdDocPhotoButtons from '../../../components/id-doc-photo-buttons';
import { useNonIdDocMachine } from '../../components/machine-provider';
import useDocName from '../../hooks/use-doc-name';
const MobileRetry = () => {
  const $ = _c(24);
  const [state, send] = useNonIdDocMachine();
  const {
    requirement,
    hasBadConnectivity,
    errors,
    allowPdf
  } = state.context;
  const {
    kind: documentRequestKind
  } = requirement.config;
  const docName = useDocName(requirement.config);
  const hideUploadButton = requirement.uploadSettings === DocumentUploadSettings.captureOnlyOnMobile || requirement.uploadSettings === DocumentUploadSettings.requireMobileCapture;
  let t0;
  if ($[0] !== send) {
    t0 = <NavigationHeader leftButton={{
      variant: "back",
      onBack: () => send({
        type: "navigatedToPrompt"
      })
    }} position="floating" />;
    $[0] = send;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== errors) {
    t1 = errors || [];
    $[2] = errors;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== docName || $[5] !== t1) {
    t2 = <ErrorComponent docName={docName} errors={t1} />;
    $[4] = docName;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== send) {
    t3 = payload => send({
      type: "receivedDocument",
      payload
    });
    $[7] = send;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = documentRequestKind !== DocumentRequestKind.ProofOfSsn;
  let t5;
  if ($[9] !== send) {
    t5 = () => send({
      type: "startImageCapture"
    });
    $[9] = send;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== allowPdf || $[12] !== hasBadConnectivity || $[13] !== hideUploadButton || $[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
    t6 = <IdDocPhotoButtons onComplete={t3} hideUploadButton={hideUploadButton} allowPdf={allowPdf} uploadFirst={t4} onTakePhoto={t5} hasBadConnectivity={hasBadConnectivity} />;
    $[11] = allowPdf;
    $[12] = hasBadConnectivity;
    $[13] = hideUploadButton;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t2 || $[19] !== t6) {
    t7 = <div className="h-full flex flex-col gap-6 items-center justify-center">{t2}{t6}</div>;
    $[18] = t2;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t0 || $[22] !== t7) {
    t8 = <FadeInContainer>{t0}{t7}</FadeInContainer>;
    $[21] = t0;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};
export default MobileRetry;